import { getStaOperatorHamaliLabel, isStaCompany } from '../../../common/helper'

export let BranchTransferHeader = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'left' }
    },
    {
        id: 1, header: 'LR No\nMan.LR No', exportHead: 'LR No\nMan.LR No', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 2, header: 'Challan\nNo', exportHead: 'Challan\nNo', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 3, header: 'Trans. Date\nTrans. Time', exportHead: 'Trans. Date\nTrans. Time', field: 'TransferDateTime', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 4, header: 'Src. City\nSrc. Br', exportHead: 'Src. City\nSrc. Br', field: 'SourceCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 5, header: 'Dest. City\nDest. Branch', exportHead: 'Dest. City\nDest. Branch', field: 'DestinationCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 6, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'Sender', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 7, header: 'Sndr. GSTIN\nSndr. eMail.', exportHead: 'Sndr. GSTIN\nSndr. eMail.', field: 'SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 8, header: 'Rcvr. Name\nRcvr. No', exportHead: 'Rcvr. Name\nRcvr. No', field: 'RecName', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 9, header: 'Rcvr. GSTIN\nRcvr. eMail', exportHead: 'Rcvr. GSTIN\nRcvr. eMail', field: 'ReceiverGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 10, header: 'Trns.\nType', exportHead: 'Trns.\nType', field: 'TransType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 11, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PaymentType', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 12, header: 'Item\nDetails', exportHead: 'Item\nDetails', field: 'ItemType', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 13, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 14, header: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 15, header: 'Cart.\nChrg.', exportHead: 'Cart.\nChrg.', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 16, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 17, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 18, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 19, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 20, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
];
export let BranchTransferHeaderOnlyFormatedLr = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'left' }
    },
    {
        id: 1, header: 'Formatted LRNO\nMan.LR No', exportHead: 'Formatted LRNO\nMan.LR No', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 2, header: 'Challan\nNo', exportHead: 'Challan\nNo', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 3, header: 'Trans. Date\nTrans. Time', exportHead: 'Trans. Date\nTrans. Time', field: 'TransferDateTime', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 4, header: 'Src. City\nSrc. Br', exportHead: 'Src. City\nSrc. Br', field: 'SourceCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 5, header: 'Dest. City\nDest. Branch', exportHead: 'Dest. City\nDest. Branch', field: 'DestinationCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 6, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'Sender', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 7, header: 'Sndr. GSTIN\nSndr. eMail.', exportHead: 'Sndr. GSTIN\nSndr. eMail.', field: 'SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 8, header: 'Rcvr. Name\nRcvr. No', exportHead: 'Rcvr. Name\nRcvr. No', field: 'RecName', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 9, header: 'Rcvr. GSTIN\nRcvr. eMail', exportHead: 'Rcvr. GSTIN\nRcvr. eMail', field: 'ReceiverGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 10, header: 'Trns.\nType', exportHead: 'Trns.\nType', field: 'TransType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 11, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PaymentType', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 12, header: 'Item\nDetails', exportHead: 'Item\nDetails', field: 'ItemType', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 13, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 14, header: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 15, header: 'Cart.\nChrg.', exportHead: 'Cart.\nChrg.', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 16, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 17, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 18, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 19, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 20, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
];
export let BranchTransferHeaderForBoth = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'left' }
    },
    {
        id: 1, header: 'LR No\nMan.LR No', exportHead: 'LR No\nMan.LR No', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 21, header: 'Formatted\nLRNO', exportHead: 'Formatted\nLRNO', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 2, header: 'Challan\nNo', exportHead: 'Challan\nNo', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 3, header: 'Trans. Date\nTrans. Time', exportHead: 'Trans. Date\nTrans. Time', field: 'TransferDateTime', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 4, header: 'Src. City\nSrc. Br', exportHead: 'Src. City\nSrc. Br', field: 'SourceCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 5, header: 'Dest. City\nDest. Branch', exportHead: 'Dest. City\nDest. Branch', field: 'DestinationCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 6, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'Sender', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 7, header: 'Sndr. GSTIN\nSndr. eMail.', exportHead: 'Sndr. GSTIN\nSndr. eMail.', field: 'SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 8, header: 'Rcvr. Name\nRcvr. No', exportHead: 'Rcvr. Name\nRcvr. No', field: 'RecName', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 9, header: 'Rcvr. GSTIN\nRcvr. eMail', exportHead: 'Rcvr. GSTIN\nRcvr. eMail', field: 'ReceiverGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 10, header: 'Trns.\nType', exportHead: 'Trns.\nType', field: 'TransType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 11, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PaymentType', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 12, header: 'Item\nDetails', exportHead: 'Item\nDetails', field: 'ItemType', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 13, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 14, header: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 15, header: 'Cart.\nChrg.', exportHead: 'Cart.\nChrg.', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 16, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 17, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 18, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 19, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 20, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
];
export const branchTransferHeaderUpdatedColumn =(UseFormattedLRinReports,loginCountryId,UseToPayAsCOD, companyId)=>{
  const lrCols = [];
  if (UseFormattedLRinReports === 3) {
    lrCols.push({
      id: 1,
      header: "LR No.\nMan. LR No.",
      exportHead: "LR Number\nManual LR Number",
      field: "LRNO^^ManualLRNo",
      isSelected: true, isDefault: true, isMandatory: true,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: "Roboto", valign: "top", minCellHeight: 36 },
      headerSx: { textAlign: "left" },weight:120, isSortIcon: true
    });
    lrCols.push({
      id: 2,
      header: "Formatted LR No",
      exportHead: "Formatted LR Number",
      field: "FormattedLRNO",
      isSelected: true, isDefault: true, isMandatory: false,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: "Roboto", valign: "top", minCellHeight: 36 },
      headerSx: { textAlign: "left" },weight:120, isSortIcon: true
    });
  }
  else if (UseFormattedLRinReports === 2) {
    lrCols.push({
      id: 1,
      header: "LR No.",
      exportHead: "LR Number",
      field: "LRNO",
      isSelected: true, isDefault: true, isMandatory: true,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 80, cellPadding: 6, font: "Roboto" },
      headerSx: { textAlign: "left",minWidth: '50px', }, weight:120, isSortIcon: true
    });
    lrCols.push({
      id: 2,
      header: "Formatted LR No",
      exportHead: "Formatted LR Number",
      field: "FormattedLRNO",
      isSelected: true, isDefault: true, isMandatory: false,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 90, cellPadding: 6, font: "Roboto" },
      headerSx: { textAlign: "left",minWidth: '50px', },weight:120, isSortIcon: true
    });
  }
  else {
    lrCols.push({
      id: 1,
      header: "LR No.\nMan. LR No.",
      exportHead: "LR Number\nManual LR Number",
      field: "LRNO^^ManualLRNo",
      isSelected: true, isDefault: true, isMandatory: true,
      xlCol: { dataType: "string", dataFormatter: null },
      pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 180, cellPadding: 6, font: "Roboto" },
      headerSx: { textAlign: "left",minWidth: '100px', },weight:120, isSortIcon: true
    });
  }
  return [
    {
        id: 0, header: 'S/N', exportHead: 'Serial Number', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'left' },weight:40, isSortIcon: false
    },
    ...lrCols,
    {
        id: 2, header: 'Challan\nNo', exportHead: 'Challan\nNumber', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 3, header: 'Trans. Date\nTrans. Time', exportHead: 'Transaction Date\nTransaction Time', field: 'TransferDateTime', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 4, header: 'Src. City\nSrc. Br', exportHead: 'Source City\nSource Branch', field: 'SourceCity^^SourceBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 5, header: 'Dest. City\nDest. Branch', exportHead: 'Destination City\nDestination Branch', field: 'DestinationCity^^DestinationBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 6, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sender Name\nSender No.', field: 'Sender^^SenderMobileNo', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 7, header: loginCountryId===2?'Sndr. eMail.':'Sndr. GSTIN\nSndr. eMail.', exportHead: loginCountryId===2?'Sender eMail':'Sender GSTIN\nSender eMail.', field: loginCountryId===2?'SenderEmailID':'SenderEmailID^^SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 8, header: 'Rcvr. Name\nRcvr. No', exportHead: 'Receiver Name\nReceiver Number', field: 'RecName^^RecMobileNo', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 9, header: loginCountryId===2?'Rcvr. eMail':'Rcvr. GSTIN\nRcvr. eMail', exportHead: loginCountryId===2?'Receiver eMail':'Receiver GSTIN\nReceiver eMail', field: loginCountryId===2?'ReceiverEmailID':'ReceiverEmailID^^ReceiverGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 10, header: 'Trns.\nType', exportHead: 'Transaction\nType', field: 'TransType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 11, header: 'Pymt.\nType', exportHead: 'Payment\nType', field: 'PaymentType', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 12, header: 'Item\nDetails', exportHead: 'Item\nDetails', field: 'ItemType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }, isSortIcon: true
    },
    {
        id: 13, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true
    },
    {
        id: 14, header: 'Frt\nChrg', exportHead: 'Freight\nCharge', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true
    },
    {
        id: 15, header: 'Cart.\nChrg.', exportHead: 'Cartage\nCharge', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true
    },
    {
        id: 16, header: 'Ham.\nChrg.', exportHead: 'Hamali\nCharge', field: 'HamaliCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true
    },
    isStaCompany(companyId) && {
        id: 21, header: getStaOperatorHamaliLabel(true), exportHead: getStaOperatorHamaliLabel(false), field: 'OperatorHamaliChg', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true
    },
    {
        id: 17, header: 'Oth.\nChrg.', exportHead: 'Other\nCharge', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true
    },
    {
        id: 18, header: UseToPayAsCOD===1?'Insu.\nChrg':'Val.\nChrg.', exportHead: UseToPayAsCOD===1?'Insurance\nCharge':'Valuation\nCharge', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true
    },
    loginCountryId!==2&&{
        id: 19, header: 'Bkg.\nGST', exportHead: 'Booking\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true
    },
    {
        id: 20, header: 'Net.\nAmt.', exportHead: 'Net\nAmount', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true
    },
].filter(Boolean)
}
export const cancelBranchTransferDetailColumns = [
    {
        id: 22, header: 'Cancelled\nby User', exportHead: 'Cancelled by User', field: 'CancelledByUser', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 110
        },
        headerSx: { minWidth: '110px', textAlign: 'left' }, weight: 110, isSortIcon: true
    },
    {
        id: 23, header: 'Logged\nUser', exportHead: 'Logged User', field: 'CancelledByBaseUser', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 110
        },
        headerSx: { minWidth: '110px', textAlign: 'left' }, weight: 110, isSortIcon: true
    },
]
export let BranchTransferHeaderForPortraitePrint = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'left' }
    },
    {
        id: 1, header: 'LR No\nMan.LR No', exportHead: 'LR No\nMan.LR No', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 2, header: 'Formatted\nLRNO', exportHead: 'Formatted\nLRNO', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 3, header: 'Challan\nNo', exportHead: 'Challan\nNo', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 4, header: 'Trans. Date\nTrans. Time', exportHead: 'Trans. Date\nTrans. Time', field: 'TransferDateTime', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 5, header: 'Src. City\nSrc. Br', exportHead: 'Src. City\nSrc. Br', field: 'SourceCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 6, header: 'Dest. City\nDest. Branch', exportHead: 'Dest. City\nDest. Branch', field: 'DestinationCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 7, header: 'Trns.\nType', exportHead: 'Trns.\nType', field: 'TransType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 8, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 9, header: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 10, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
];
export let BranchTransferHeaderForRemoveGST = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'sno', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 40,
        },
        headerSx: { minWidth: '50px', textAlign: 'left' }
    },
    {
        id: 1, header: 'LR No\nMan.LR No', exportHead: 'LR No\nMan.LR No', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    // {
    //     id: 21, header: 'Formatted\nLRNO', exportHead: 'Formatted\nLRNO', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
    //     pdfColSx: {
    //         halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
    //     },
    //     headerSx: { minWidth: '100px', textAlign: 'left' }
    // },
    {
        id: 2, header: 'Challan\nNo', exportHead: 'Challan\nNo', field: 'ChallanNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 3, header: 'Trans. Date\nTrans. Time', exportHead: 'Trans. Date\nTrans. Time', field: 'TransferDateTime', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 4, header: 'Src. City\nSrc. Br', exportHead: 'Src. City\nSrc. Br', field: 'SourceCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 5, header: 'Dest. City\nDest. Branch', exportHead: 'Dest. City\nDest. Branch', field: 'DestinationCity', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 6, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'Sender', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 7, header: 'Sndr. eMail.', exportHead: 'Sndr. eMail.', field: 'SenderGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 8, header: 'Rcvr. Name\nRcvr. No', exportHead: 'Rcvr. Name\nRcvr. No', field: 'RecName', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '120px', textAlign: 'left' }
    },
    {
        id: 9, header: 'Rcvr. eMail', exportHead: 'Rcvr. eMail', field: 'ReceiverGSTN', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 120
        },
        headerSx: { minWidth: '150px', textAlign: 'left' }
    },
    {
        id: 10, header: 'Trns.\nType', exportHead: 'Trns.\nType', field: 'TransType', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '100px', textAlign: 'left' }
    },
    {
        id: 11, header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PaymentType', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 12, header: 'Item\nDetails', exportHead: 'Item\nDetails', field: 'ItemType', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
        pdfColSx: {
            halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'left' }
    },
    {
        id: 13, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Units', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'quantity', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 14, header: 'Frt\nChrg', exportHead: 'Frt\nChrg', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 15, header: 'Cart.\nChrg.', exportHead: 'Cart.\nChrg.', field: 'CartageAmount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 16, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'HamaliCharge', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 17, header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    {
        id: 18, header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
    // {
    //     id: 19, header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'currency', dataFormatter: null },
    //     pdfColSx: {
    //         halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
    //     },
    //     headerSx: { minWidth: '80px', textAlign: 'right' }
    // },
    {
        id: 19, header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'currency', dataFormatter: null },
        pdfColSx: {
            halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellHeight: 36, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellWidth: 80
        },
        headerSx: { minWidth: '80px', textAlign: 'right' }
    },
];


export const calculateTotalTableWidth = (columns) => {
    let totalWidth = 0;

    columns.forEach((column) => {
        const minCellWidth = column.pdfColSx.minCellWidth;
        totalWidth += minCellWidth;
    });

    return totalWidth;
};
export const calculateDynamicFormatLandscape = (desiredWidth) => {
    // Standard A4 landscape aspect ratio: width / height = 297 / 210
    const a4LandscapeAspectRatio = 1122 / 793;

    // Calculate the height based on the aspect ratio
    const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

    return [desiredWidth, dynamicHeight];
};
export const calculateDynamicFormatPortrait = (desiredWidth) => {
    // Standard A4 Portrait aspect ratio: width / height = 297 / 210
    const a4LandscapeAspectRatio = 793 / 1122;

    // Calculate the height based on the aspect ratio
    const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

    return [desiredWidth, dynamicHeight];
};

// export const BranchTransferExcelHeader = [
//     { header: 'S/N', field: 'sno' },
//     { header: 'LR No', field: 'LRNO' },
//     { header: 'Man.LR No', field: 'LRNO' },
//     { header: 'Challan No', field: 'ChallanNo' },
//     { header: 'Trans. Date', field: 'TransferDateTime' },
//     { header: 'Trans. Time', field: 'TransferDateTime' },
//     { header: 'Src. City', field: 'SourceCity' },
//     { header: 'Src. Br', field: 'SourceCity' },
//     { header: 'Dest. City', field: 'DestinationCity' },
//     { header: 'Dest. Branch', field: 'DestinationCity' },
//     { header: 'Sndr. Name', field: 'Sender' },
//     { header: 'Sndr. No.', field: 'Sender' },
//     { header: 'Sndr. GSTIN', field: 'SenderGSTN' },
//     { header: 'Sndr. eMail.', field: 'SenderGSTN' },
//     { header: 'Rcvr. Name', field: 'RecName' },
//     { header: 'Rcvr. No', field: 'RecName' },
//     { header: 'Rcvr. GSTIN', field: 'ReceiverGSTN' },
//     { header: 'Rcvr. eMail', field: 'ReceiverGSTN' },
//     { header: 'Trns. Type', field: 'TransType' },
//     { header: 'Pymt. Type', field: 'PaymentType' },
//     { header: 'Item Details', field: 'ItemType' },
//     { header: 'Item Units', field: 'Units' },
//     { header: 'Frt Chrg', field: 'Freight' },
//     { header: 'Cart. Chrg.', field: 'CartageAmount' },
//     { header: 'Ham. Chrg.', field: 'HamaliCharge' },
//     { header: 'Oth. Chrg.', field: 'OtherCharges' },
//     { header: 'Val. Chrg.', field: 'Valuation' },
//     { header: 'Bkg. GST', field: 'BookingGST' },
//     { header: 'Net. Amt.', field: 'NetAmount' },
// ];
export const getBranchTransferExcelHeader = (loginCountryId, UseFormattedLRinReports, selectedFields = {}) => {
    let columns = [
        { header: 'Serial Number', field: 'sno' },
        { header: 'LRNumber', field: 'LRNO' },
        { header: 'Manual LR Number', field: 'LRNO' },
        { header: 'Challan Number', field: 'ChallanNo' },
        { header: 'Transaction Date', field: 'TransferDateTime' },
        { header: 'Transaction Time', field: 'TransferDateTime' },
        { header: 'Source City', field: 'SourceCity' },
        { header: 'Source Branch', field: 'SourceCity' },
        { header: 'Destination City', field: 'DestinationCity' },
        { header: 'Destination Branch', field: 'DestinationCity' },
        { header: 'Sender Name', field: 'Sender' },
        { header: 'Sender Number', field: 'Sender' },
        { header: 'Sender GSTIN', field: 'SenderGSTN' },
        { header: 'Sender eMail.', field: 'SenderGSTN' },
        { header: 'Receiver Name', field: 'RecName' },
        { header: 'Receiver Number', field: 'RecName' },
        { header: 'Receiver GSTIN', field: 'ReceiverGSTN' },
        { header: 'Receiver eMail', field: 'ReceiverGSTN' },
        { header: 'Transaction Type', field: 'TransType' },
        { header: 'Payment Type', field: 'PaymentType' },
        { header: 'Item Details', field: 'ItemType' },
        { header: 'Item Units', field: 'Units' },
        { header: 'Freight Charge', field: 'Freight' },
        { header: 'Cartage Charge', field: 'CartageAmount' },
        { header: 'Hamali Charge', field: 'HamaliCharge' },
        { header: getStaOperatorHamaliLabel(false), field: 'OperatorHamaliChg' },
        { header: 'Other Charge', field: 'OtherCharges' },
        { header: 'Valuation Charge', field: 'Valuation' },
        { header: 'Booking GST', field: 'BookingGST' },
        { header: 'Net Amount', field: 'NetAmount' },
    ];
    if (loginCountryId === 2) {
        columns = columns.filter(col => col.field !== 'BookingGST');
    }
    if (UseFormattedLRinReports !== 3) {
        columns = columns.filter(col => col.field !== 'FormattedLRNO');
    }
    columns = columns.map(col => {
        if (col.field === 'Valuation') {
            return {
                ...col,
                header: loginCountryId === 2 ? 'Insurance Charge' : 'Valuation Charge',
            };
        }
        return col;
    });
    if (selectedFields && Object.keys(selectedFields).length > 0) {
        columns = columns.filter(col => selectedFields[col.field]);
    }

    return columns;
};
export const BranchTransferExcelHeaderFormattedLRNO = [
    { header: 'S/N', field: 'sno' },
    { header: 'Formatted LRNO', field: 'FormattedLRNO' },
    { header: 'Man.LR No', field: 'LRNO' },
    { header: 'Challan No', field: 'ChallanNo' },
    { header: 'Trans. Date', field: 'TransferDateTime' },
    { header: 'Trans. Time', field: 'TransferDateTime' },
    { header: 'Src. City', field: 'SourceCity' },
    { header: 'Src. Br', field: 'SourceCity' },
    { header: 'Dest. City', field: 'DestinationCity' },
    { header: 'Dest. Branch', field: 'DestinationCity' },
    { header: 'Sndr. Name', field: 'Sender' },
    { header: 'Sndr. No.', field: 'Sender' },
    { header: 'Sndr. GSTIN', field: 'SenderGSTN' },
    { header: 'Sndr. eMail.', field: 'SenderGSTN' },
    { header: 'Rcvr. Name', field: 'RecName' },
    { header: 'Rcvr. No', field: 'RecName' },
    { header: 'Rcvr. GSTIN', field: 'ReceiverGSTN' },
    { header: 'Rcvr. eMail', field: 'ReceiverGSTN' },
    { header: 'Trns. Type', field: 'TransType' },
    { header: 'Pymt. Type', field: 'PaymentType' },
    { header: 'Item Details', field: 'ItemType' },
    { header: 'Item Units', field: 'Units' },
    { header: 'Frt Chrg', field: 'Freight' },
    { header: 'Cart. Chrg.', field: 'CartageAmount' },
    { header: 'Ham. Chrg.', field: 'HamaliCharge' },
    { header: 'Oth. Chrg.', field: 'OtherCharges' },
    { header: 'Val. Chrg.', field: 'Valuation' },
    { header: 'Bkg. GST', field: 'BookingGST' },
    { header: 'Net. Amt.', field: 'NetAmount' },
];
export const BranchTransferExcelHeaderForBoth = [
    { header: 'S/N', field: 'sno' },
    { header: 'LR No', field: 'LRNO' },
    { header: 'Man.LR No', field: 'LRNO' },
    { header: 'Formatted LRNO', field: 'FormattedLRNO' },
    { header: 'Challan No', field: 'ChallanNo' },
    { header: 'Trans. Date', field: 'TransferDateTime' },
    { header: 'Trans. Time', field: 'TransferDateTime' },
    { header: 'Src. City', field: 'SourceCity' },
    { header: 'Src. Br', field: 'SourceCity' },
    { header: 'Dest. City', field: 'DestinationCity' },
    { header: 'Dest. Branch', field: 'DestinationCity' },
    { header: 'Sndr. Name', field: 'Sender' },
    { header: 'Sndr. No.', field: 'Sender' },
    { header: 'Sndr. GSTIN', field: 'SenderGSTN' },
    { header: 'Sndr. eMail.', field: 'SenderGSTN' },
    { header: 'Rcvr. Name', field: 'RecName' },
    { header: 'Rcvr. No', field: 'RecName' },
    { header: 'Rcvr. GSTIN', field: 'ReceiverGSTN' },
    { header: 'Rcvr. eMail', field: 'ReceiverGSTN' },
    { header: 'Trns. Type', field: 'TransType' },
    { header: 'Pymt. Type', field: 'PaymentType' },
    { header: 'Item Details', field: 'ItemType' },
    { header: 'Item Units', field: 'Units' },
    { header: 'Frt Chrg', field: 'Freight' },
    { header: 'Cart. Chrg.', field: 'CartageAmount' },
    { header: 'Ham. Chrg.', field: 'HamaliCharge' },
    { header: 'Oth. Chrg.', field: 'OtherCharges' },
    { header: 'Val. Chrg.', field: 'Valuation' },
    { header: 'Bkg. GST', field: 'BookingGST' },
    { header: 'Net. Amt.', field: 'NetAmount' },
];
export const BranchTransferExcelHeaderForRemoveGST = [
    { header: 'S/N', field: 'sno' },
    { header: 'LR No', field: 'LRNO' },
    { header: 'Man.LR No', field: 'LRNO' },
    { header: 'Formatted LRNO', field: 'FormattedLRNO' },
    { header: 'Challan No', field: 'ChallanNo' },
    { header: 'Trans. Date', field: 'TransferDateTime' },
    { header: 'Trans. Time', field: 'TransferDateTime' },
    { header: 'Src. City', field: 'SourceCity' },
    { header: 'Src. Br', field: 'SourceCity' },
    { header: 'Dest. City', field: 'DestinationCity' },
    { header: 'Dest. Branch', field: 'DestinationCity' },
    { header: 'Sndr. Name', field: 'Sender' },
    { header: 'Sndr. No.', field: 'Sender' },
    { header: 'Sndr. eMail.', field: 'SenderGSTN' },
    { header: 'Rcvr. Name', field: 'RecName' },
    { header: 'Rcvr. No', field: 'RecName' },
    { header: 'Rcvr. eMail', field: 'ReceiverGSTN' },
    { header: 'Trns. Type', field: 'TransType' },
    { header: 'Pymt. Type', field: 'PaymentType' },
    { header: 'Item Details', field: 'ItemType' },
    { header: 'Item Units', field: 'Units' },
    { header: 'Frt Chrg', field: 'Freight' },
    { header: 'Cart. Chrg.', field: 'CartageAmount' },
    { header: 'Ham. Chrg.', field: 'HamaliCharge' },
    { header: 'Oth. Chrg.', field: 'OtherCharges' },
    { header: 'Val. Chrg.', field: 'Valuation' },
    { header: 'Net. Amt.', field: 'NetAmount' },
];

// Rest of the code remains unchanged...
export const branchTransferFilterHeader = [
    { header: 'Company Name', field: 'CompanyName', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:5},
    { header: 'From Date', field: 'FromDate', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left',col:5 },
    { header: 'To Date',field: 'ToDate', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right',col:5},
    { header: 'Report', field: 'Report', xlCol: { dataType: 'number', dataFormatter: null }, align: 'right',col:5 },
    { header: 'Vehicle No', field: 'VehicleNo', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:5},
    { header: 'From Branch Name', field: 'fromBranchName', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:5},
    { header: 'Payment Type', field: 'payment', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:5},
    { header: 'To Branch Name', field: 'toBranchName', xlCol: { dataType: 'string', dataFormatter: null }, align: 'right',col:5},
]